import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const sorted = [...comics].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  ).slice(0, 8);

  const formatViews = (views: number) => {
    if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
    return String(views);
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="mt-2 text-sm text-foreground-500">实时追踪你最爱的漫画更新</p>
          </div>
          <span className="text-xs text-foreground-400 bg-background-100 px-3 py-1.5 rounded-full">
            更新时间：{new Date().toLocaleDateString('zh-CN')}
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {sorted.map((comic) => {
            const latestChapter = comic.chapters[0];
            return (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="group flex items-center gap-4 p-4 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors"
              >
                <div className="w-16 h-20 rounded-md overflow-hidden flex-shrink-0">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    title={`${comic.title} - 最新第${latestChapter?.number || '?'}话`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                  <div className="flex items-center gap-3 mt-1.5">
                    <span className="text-xs text-primary-600 font-medium">
                      {latestChapter ? `更新至${latestChapter.number}话` : '暂无更新'}
                    </span>
                    <span className="text-xs text-foreground-400">
                      <i className="ri-eye-line text-xs mr-0.5" />
                      {formatViews(comic.views)}
                    </span>
                  </div>
                </div>
                <div className="flex-shrink-0">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                    comic.category === 'kr' ? 'bg-primary-100 text-primary-700' :
                    comic.category === 'jp' ? 'bg-accent-100 text-accent-700' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>
                    {comic.categoryLabel}
                  </span>
                </div>
                <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors hidden sm:block" />
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}